import { BrowserRouter as Router, Route, Routes,  Link } from "react-router-dom";
import HomePage from "./pages/Home/home";
import LoginPage from "./pages/Login/loginpage";
import DashboardEmpresa from "./pages/Empresa/EmpresaPage";
import DashboardTrucks from "./pages/Empresa/Companytrucks";
import TrucksDetailRoute from "./pages/Empresa/Truckroutes";
import SuscripcionPage from "./pages/Empresa/Suscripcionpage";
import LocationPage from "./pages/Empresa/LocationPage";
import TransactionPage from "./pages/Empresa/Transactionpage";
import ContactPage from "./pages/Empresa/ContactPage";
import UserInitPage from "./pages/Usuario/usuariopage";
import MySuscripcionUserPage from "./pages/Usuario/MysuscriptionUserpage";
import ScheduleRoutePage from "./pages/Usuario/ScheduleRoute";
import LocationUser from "./pages/Usuario/LocationUserPage";
import SuscripcionTransaccion from "./pages/Usuario/MysuscripcionTransaction";
import PaymentPage from "./pages/Usuario/paymentPage";




const App = () => {  
  return (
    <Router>     
      <Routes>
        <Route path="/" element={<HomePage />} />   
        <Route path="/login" element={<LoginPage />} />  
        <Route path="/empresas" element={<DashboardEmpresa />} />   
        <Route path="/empresas/trucks" element={<DashboardTrucks />} />   
        <Route path="/empresas/trucks/detail" element={<TrucksDetailRoute />} />  
        <Route path="/empresas/suscripcion" element={<SuscripcionPage />} />  
        <Route path="/empresas/location" element={<LocationPage />} /> 
        <Route path="/empresas/transaction" element={<TransactionPage />} /> 
        <Route path="/contact" element={<ContactPage />} /> 
        <Route path="/user" element={<UserInitPage />} />
        <Route path="/user/suscripcion" element={<MySuscripcionUserPage />} />  
        <Route path="/user/programacion" element={<ScheduleRoutePage />} />  
        <Route path="/user/location" element={<LocationUser />} />  
        <Route path="/user/suscripcion/transaccion" element={<SuscripcionTransaccion />} /> 
        <Route path="/user/suscripcion/payment" element={<PaymentPage />} /> 
      </Routes>
    </Router>
  );
};

export default App;
